import React, { createContext, useContext, useState } from 'react';

const ProposalContext = createContext();

export const useProposal = () => {
  const context = useContext(ProposalContext);
  if (!context) {
    throw new Error('useProposal must be used within a ProposalProvider');
  }
  return context;
};

export const ProposalProvider = ({ children }) => {
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [pendingProposalNavigation, setPendingProposalNavigation] = useState(null);

  return (
    <ProposalContext.Provider value={{
      selectedProposal,
      setSelectedProposal,
      pendingProposalNavigation,
      setPendingProposalNavigation
    }}>
      {children}
    </ProposalContext.Provider>
  );
}; 